var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('basic-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [(_vm.showNav)?_c('nav',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1):_vm._e()]},proxy:true}])},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }